import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import Detail from './components/detail';
import { getInfo as _getInfo, getList as _getList, modifySort } from "@api/setting/dictionary";
import Sortable from 'sortablejs';
export default {
  name: "setting-dictionary",
  computed: {
    disabledSort: function disabledSort() {
      return this.typeCode === '';
    }
  },
  data: function data() {
    return {
      filterData: [{
        name: '所有',
        value: ''
      }],
      toSort: false,
      currentTableData: [],
      loading: false,
      template: null,
      currentPage: 1,
      pageSize: 30,
      total: 0,
      canBeCreate: false,
      typeCode: '',
      columns: [{
        name: '字典类型',
        key: 'n04Name',
        slot: 'name'
      }, {
        name: '字典值',
        key: 'n04Value'
      }, {
        name: '扩展值',
        key: 'n04ExtValue'
      }, {
        name: '引用数',
        key: 'n04QuoteNum'
      }, {
        name: '排序值',
        key: 'n04Sort',
        slot: 'sort'
      }, {
        name: '状态',
        key: 'n04Enabled',
        slot: 'state'
      }],
      timer: null,
      table: null
    };
  },
  methods: {
    back: function back() {
      this.toSort = false;
      this.sortTable(false);
    },
    save: function save() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$$confirm('确定变更排序?');
            case 1:
              _this.loading = true;
              _context.n = 2;
              return _this.$awaitTo(modifySort(_this.currentTableData));
            case 2:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _this.$message.success('操作成功');
              _this.getList();
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleSizeChange: function handleSizeChange(size) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.pageSize = size;
              _this2.handleCurrentChange(1);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    sortTable: function sortTable(val) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.getList();
            case 1:
              if (val) {
                _this3.rowDrop();
              } else {
                _this3.disabledTableSort();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    disabledTableSort: function disabledTableSort() {
      if (this.table) {
        this.table.option('disabled', true);
        this.table.destroy();
      }
    },
    create: function create(type) {
      var _arguments = arguments,
        _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var item, _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              item = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
              _context4.n = 1;
              return _this4.$awaitTo(_this4.$dialog(Detail, {
                dialog: {
                  title: type === 'create' ? '新增' : '编辑'
                },
                props: {
                  code: type === 'create' ? _this4.typeCode : item.n04FieldName,
                  typeName: type === 'create' ? _this4.typeName : item.n04Name,
                  type: type,
                  id: type === 'edit' ? item.n04Id : undefined,
                  data: item,
                  first: Array.isArray(_this4.currentTableData) && _this4.currentTableData.length ? _this4.currentTableData[0] : undefined
                }
              }, function (template) {
                _this4.template = template;
              }));
            case 1:
              _yield$_this4$$awaitT = _context4.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 2);
              err = _yield$_this4$$awaitT2[0];
              data = _yield$_this4$$awaitT2[1];
              _this4.template = null;
              if (!err) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              _this4.getList();
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    handleTakState: function handleTakState(item) {
      this.typeCode = item.value;
      this.typeName = item.name;
      if (item.value === '') {
        this.toSort = false;
        this.disabledTableSort();
      }
      this.handleCurrentChange(1);
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    getInfo: function getInfo() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$_this5$$awaitT, _yield$_this5$$awaitT2, err, data, _this5$filterData;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$awaitTo(_getInfo());
            case 1:
              _yield$_this5$$awaitT = _context5.v;
              _yield$_this5$$awaitT2 = _slicedToArray(_yield$_this5$$awaitT, 2);
              err = _yield$_this5$$awaitT2[0];
              data = _yield$_this5$$awaitT2[1].data;
              if (!err) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              if (data && Array.isArray(data.dictionaryType)) {
                (_this5$filterData = _this5.filterData).push.apply(_this5$filterData, _toConsumableArray(data.dictionaryType.map(function (item) {
                  return {
                    name: item.text,
                    value: item.value
                  };
                })));
              }
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getList: function getList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _yield$_this6$$awaitT, _yield$_this6$$awaitT2, err, data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this6.loading = true;
              _context6.n = 1;
              return _this6.$awaitTo(_getList({
                page: _this6.currentPage,
                length: _this6.toSort ? 99999 : _this6.pageSize,
                type: _this6.typeCode
              }));
            case 1:
              _yield$_this6$$awaitT = _context6.v;
              _yield$_this6$$awaitT2 = _slicedToArray(_yield$_this6$$awaitT, 2);
              err = _yield$_this6$$awaitT2[0];
              data = _yield$_this6$$awaitT2[1].data;
              _this6.loading = false;
              if (!err) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2, Promise.reject());
            case 2:
              if (Array.isArray(data.datas)) {
                _this6.currentTableData = data.datas.sort(function (a, b) {
                  return a.n04Sort - b.n04Sort;
                });
                _this6.total = data.total;
              }
              return _context6.a(2, Promise.resolve());
          }
        }, _callee6);
      }))();
    },
    rowDrop: function rowDrop() {
      var tbody = document.querySelector('.el-table__body-wrapper tbody');
      var self = this;
      this.table = Sortable.create(tbody, {
        disabled: !self.toSort,
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
            oldIndex = _ref.oldIndex;
          if (newIndex !== oldIndex) {
            var currRow = self.currentTableData.splice(oldIndex, 1)[0];
            self.currentTableData = self.currentTableData.map(function (item, index) {
              return _objectSpread(_objectSpread({}, item), {}, {
                n04Sort: index > newIndex ? item.n04Sort : index < newIndex ? item.n04Sort : newIndex + 1
              });
            });
            var maxSort = self.currentTableData[self.currentTableData.length - 1].n04Sort;
            self.currentTableData.splice(newIndex, 0, _objectSpread(_objectSpread({}, currRow), {}, {
              n04Sort: self.currentTableData.length === newIndex ? maxSort + 1 : newIndex
            }));
          }
        }
      });
    }
  },
  created: function created() {
    this.getInfo();
    this.getList();
  },
  mounted: function mounted() {
    // clearTimeout(this.timer);
    // this.timer = setTimeout(() => {
    //   this.rowDrop()
    // }, 500)
  }
};